import { Box } from "@mui/material";
import {
  SmartForm,
  SmartSubmit,
  SmartTextField,
} from "@nodeon/react-components";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  ApiResponse,
  usePortApi,
  VesselContactDetailsDto,
} from "~/api/GeneratedApi";
import { useCustomMutation } from "~/utils/hooks/useCustomMutation";
import { useCustomQueryClient } from "~/utils/hooks/useCustomQueryClient";

interface Props {
  mmsi: number;
  contactInfos: VesselContactDetailsDto[] | undefined;
}

type FormData = {
  contactInfo: string;
};

export const VesselContactForm = ({
  mmsi,
  contactInfos,
}: Props): JSX.Element => {
  const { editVesselContact } = usePortApi();
  const { t } = useTranslation("vessels");
  const { invalidateCustomQueries } = useCustomQueryClient();

  const formProps = React.useMemo(
    () => ({
      defaultValues: { contactInfo: contactInfos?.[0]?.infoField ?? "" },
    }),
    [contactInfos],
  );

  const { mutateAsync: editContactAsync } = useCustomMutation(
    (d: FormData) => editVesselContact(d.contactInfo, mmsi),
    {
      onSuccess: () => invalidateCustomQueries("vessel-locations"),
    },
  );

  return (
    <Box mt={2}>
      <SmartForm<FormData, ApiResponse>
        formProps={formProps}
        onSubmit={editContactAsync}
        gridProps={{ direction: "column" }}
      >
        <SmartTextField<FormData>
          name="contactInfo"
          gridProps={{ xs: true }}
          fullWidth
          multiline
          variant="outlined"
          minRows={2}
          label={t("contact-info")}
        />
        <SmartSubmit />
      </SmartForm>
    </Box>
  );
};
